import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

export const ButtonTabContainer = styled.span`
  margin: ${token('space.300')} 0;
  display: inline-block;
  .button-tab {
    border-radius: 40px;
    font-size: 14px;
    font-weight: normal;
    margin-right: ${token('space.100')};
    background-color: ${token('color.background.neutral')};
    color: ${token('color.text.subtlest')} !important; // Override the default color
    &-warning {
      background-color: ${token('color.background.warning.bold')};
      color: ${token('color.text.warning.inverse')} !important;
    }
    &-active {
      background-color: ${token('color.background.selected')};
      color: ${token('color.text.selected')} !important; // Override the white color
    }
  }
`;

export const HomePageWidgetContainer = styled.div`
  .ppc-home-widget {
    width: 100%;
    height: 376px;
    box-shadow: none;
    .align-self-center {
      align-self: center;
    }
    .ppc-widget-content {
      padding: 0;
      .widget-item {
        border-bottom: 1px solid ${token('color.background.accent.gray.subtlest')};
        padding: 0 ${token('space.100')};
        &:last-child {
          // Caveat: Considering that .widget-footer is the last child
          border-bottom: none;
        }
        &-danger {
          // Used for overdue invoices background color
          background-color: ${token('color.background.accent.red.subtlest')};
        }
        &-recently-viewed {
          > .subscription-widget-item,
          > .customer-address-widget-item,
          > .cloud-site-widget-item {
            align-items: center;
            padding-top: ${token('space.075')};
            padding-bottom: ${token('space.075')};
            margin-bottom: 0;
          }
          .left-side {
            line-height: normal; // Appropriate line-height between title and sub-title
          }
          .content {
            .title {
              font-size: ${token('font.family.body')};
              align-self: center;
            }
            .sub-title {
              min-height: initial;
              margin-top: 0;
            }
            .sub-title,
            .timestamp {
              color: ${token('color.text.subtlest')};
            }
            .widget-item-icon {
              width: 24px;
              height: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              align-self: center;
              color: ${token('color.icon')};
              border-radius: ${token('space.050')};
              background: ${token('color.background.accent.gray.subtler')};
              margin-right: ${token('space.100')};
            }
            .entitlement-icon {
              align-self: center;
            }
          }
        }
      }
    }
    .widget-footer-v2 {
      padding-bottom: 0;
    }
    a,
    a:hover {
      color: inherit !important; // Override the default blue color
    }
  }
`;
